<template>
	<div id="address-picker">
		<input v-if="prop_id" type="hidden" name="address[id]" :value="prop_id">
		<input type="hidden" name="address[latitude]" :value="location ? location.lat : 0">
		<input type="hidden" name="address[longitude]" :value="location ? location.lng : 0">
		<input type="hidden" :value="location ? location.address : 0">

		 <label>
			Address
			<GmapAutocomplete name="address[street_address]" :value="prop_address" @place_changed="setPlace"></GmapAutocomplete>
		</label>
		<br/>
		<label v-if="prop_show_gps && location.lat && location.lng">Latitude: {{ location.lat | formatCoOrdinate }}, Longitude: {{ location.lng | formatCoOrdinate}}</label>
		<GmapMap :zoom="zoomLevel" :center="location.lat && location.lng ? location : {lat: 0, lng: 0}">
			<GmapMarker
				v-if="location.lat && location.lng"
				label="★"
				:position="location"
				:draggable="true"
				@dragend="setLocation"
			/>
		</GmapMap>
	</div>
</template>

<script>
	export default {
		components: {},
		name: 'addressPicker',
		props: {
			prop_id: { default: null },
			prop_latitude: {},
			prop_longitude: {},
			prop_address: {},
			prop_show_gps: { default: false}
		},
		data() {
			return {
				place: null,
				zoomLevel: 1,
				location: {lat: null, lng: null}
			}
		},
		methods: {
			setPlace(place) {
				this.place = place;
				this.zoomLevel = 15;

				this.location = {
					address: place.formatted_address,
					lat: this.place.geometry.location.lat(),
					lng: this.place.geometry.location.lng()
				};
			},
			setLocation(marker) {
				this.location.lat = marker.latLng.lat();
				this.location.lng = marker.latLng.lng();
			}
		},
		filters: {
			formatCoOrdinate: function(value) {
				return parseFloat(value).toFixed(6);
			}
		},
		mounted() {
			if(this.prop_latitude && this.prop_longitude) {
				this.location = {
					address: this.prop_address,
					lat: parseFloat(this.prop_latitude),
					lng: parseFloat(this.prop_longitude)
				}
				this.zoomLevel = 15;
			} else {
				this.location.address = this.prop_address;
			}

			console.log(this.prop_show_gps);
		}
	}
</script>

<style lang="scss" scoped>
	#address-picker {
		.vue-map-container {
			width: 600px;
			height: 300px;
		}
	}
</style>


// WEBPACK FOOTER //
// assets/js/vue/elements/AddressPicker.vue